import { Dropdown } from 'components/ui'
import { Article, Title, Items, Content } from './Style'

const Faq = () => {
  return (
    <>
      <Title>_faq</Title>
      <Article>
        <Items>
          <Dropdown title='What is _mad-assembly?'>
            <Content>
              This decentralized application (DApp) empowers users to&nbsp;efficiently send thousands of&nbsp;tokens
              to&nbsp;multiple addresses through batching and automation. It&nbsp;streamlines the process and saves
              user&rsquo;s time by&nbsp;automatically generating transactions via MetaMask. Additionally, _mad-assembly
              enhances security by&nbsp;enabling users to&nbsp;entrust the safety of&nbsp;their private keys
              to&nbsp;a&nbsp;secure MetaMask wallet.
            </Content>
          </Dropdown>
          <Dropdown title='Is _mad-assembly safe?'>
            <Content>
              Yes, _mad-assembly&nbsp;is completely safe. We&nbsp;don&rsquo;t have any access to&nbsp;your
              wallet&rsquo;s information or&nbsp;private keys.
            </Content>
          </Dropdown>
          <Dropdown title='What is the average time required for airdropping?'>
            <Content>
              It&nbsp;depends on&nbsp;the gas price and network congestion. Usually, it&nbsp;requires from
              3&nbsp;to&nbsp;5&nbsp;minutes.
            </Content>
          </Dropdown>
          <Dropdown title='What wallets are compatible?'>
            <Content>
              You have the choice of&nbsp;using Metamask, Coinbase wallet, WalletConnect, hardware wallets or&nbsp;any
              other wallet compatible with Rainbow.
            </Content>
          </Dropdown>
          <Dropdown title='What is the pricing for using _mad-assembly?'>
            <Content>
              The transaction cost varies based on&nbsp;your ERC-20 token setup, the quantity of&nbsp;addresses, network
              parameters, and the tokens being sent. To&nbsp;get an&nbsp;accurate fee estimate, it&rsquo;s recommended
              to&nbsp;use the tool, and the cost for your planned airdrop will be&nbsp;shown before confirming. This
              process typically takes only 2-3&nbsp;minutes.
            </Content>
          </Dropdown>
          <Dropdown title='Is it possible to test the application on a Testnet?'>
            <Content>
              Certainly! To&nbsp;ensure everything works as&nbsp;expected you can use Goerli test network.
            </Content>
          </Dropdown>
          <Dropdown title='What is the maximum number of addresses for an airdrop?'>
            <Content>
              There are no&nbsp;limitations. You can send an&nbsp;unlimited number of&nbsp;tokens to&nbsp;as&nbsp;many
              addresses as&nbsp;needed.
            </Content>
          </Dropdown>
          <Dropdown title='How many addresses are in the batch?'>
            <Content>
              _mad-assembly organizes your recipients&rsquo; addresses into batches for splitting into multiple
              transactions. Each batch can accommodate from 200 to 400&nbsp;addresses, depending on&nbsp;the specifics
              of&nbsp;your ERC-20 token implementation.
            </Content>
          </Dropdown>
          <Dropdown title='Which chains does _mad-assembly support?'>
            <Content>
              The application&nbsp;presently supports Ethereum Mainnet, Binance Smart Chain and Polygon Chain.
            </Content>
          </Dropdown>
          <Dropdown title='How can I switch from one blockchain to another?'>
            <Content>
              By&nbsp;selecting the button with the chain icon located in&nbsp;the upper-right corner of&nbsp;the page.
            </Content>
          </Dropdown>
          <Dropdown title='What does «Approve» mean?'>
            <Content>
              That means that you give permission to&nbsp;the app contract to&nbsp;transfer your tokens to&nbsp;the
              provided addresses.
            </Content>
          </Dropdown>
          <Dropdown title='During the second step, I encounter this error message: Insufficient approval amount.'>
            <Content>
              The application performs a&nbsp;simulated airdrop to&nbsp;ensure that all is&nbsp;in&nbsp;order and will
              proceed smoothly. For this operation, your balance must exceed the amount indicated in&nbsp;the error
              message. Please deposit additional funds to&nbsp;your balance.
            </Content>
          </Dropdown>
          <Dropdown title='What is a self-generated key?'>
            <Content>
              This is&nbsp;the fastest recommended way to&nbsp;use _mad-assembly. The dApp generates the&nbsp;burner key
              on&nbsp;your device. After the burner key receives the funds, it&nbsp;will automatically post all your
              transactions on&nbsp;the blockchain.
            </Content>
          </Dropdown>
        </Items>
      </Article>
    </>
  )
}

export { Faq }
